window.cloneCart = window.cloneCart || function cloneCart() {
  const cartTotal = document.getElementById('cartSubTotal');
  const cartNav = document.getElementById('cartNav');

  if (!cartTotal || !cartNav) return;

  const clonedCart = cartTotal.cloneNode(true);
  clonedCart.id = 'sticky_headerTotal';
  cartNav.replaceChildren(clonedCart);

  document.querySelectorAll('tr.cart-item').forEach((cartItem) => {
    const dataId = cartItem.getAttribute('data-id');
    if (!dataId) return;

    const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);
    if (drawerFooter) drawerFooter.classList.add('Gift-Wrapper__hide');
  });
};

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.spinner = this.querySelector('.loading-overlay__spinner');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.error = false;

      if (!this.form || !this.submitButton) return;

      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    async onSubmitHandler(event) {
      event.preventDefault();

      if (!this.form || !this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.error = false;
      this.handleErrorMessage();
      this.setLoading(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        const sectionIds = this.cart
          .getSectionsToRender()
          .map((section) => section.id)
          .filter(Boolean);

        if (sectionIds.length) formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);

        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }

      config.body = formData;

      try {
        const request = await fetch(routes.cart_add_url, config);
        const parsedState = await request.json();

        if (!request.ok || parsedState.status) {
          this.handleErrorMessage(parsedState.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.error = true;
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.querySelector('span')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }

          return;
        }

        if (!this.cart || typeof this.cart.renderContents !== 'function') {
          window.location.assign(window.routes.cart_url);
          return;
        }

        const renderCart = () => {
          this.cart.renderContents(parsedState);
          window.requestAnimationFrame(() => window.cloneCart());
        };

        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', renderCart, { once: true });
          quickAddModal.hide(true);
        } else {
          renderCart();
        }
      } catch (error) {
        console.error('Unable to add item to cart:', error);
      } finally {
        this.setLoading(false);

        if (this.cart?.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }

        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      }
    }

    setLoading(isLoading) {
      if (!this.submitButton) return;

      this.submitButton.toggleAttribute('aria-disabled', isLoading);
      this.submitButton.classList.toggle('loading', isLoading);
      this.spinner?.classList.toggle('hidden', !isLoading);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.cloneCart, { once: true });
} else {
  window.cloneCart();
}
